var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8051 25.7316C42.1753 25.9156 42.1758 26.4444 41.8054 26.628L22.152 36.3669C22.01 36.4373 21.8422 36.4359 21.7011 36.3636L2.22958 26.383C1.86358 26.1954 1.86781 25.6702 2.23689 25.4888L21.6606 15.9398C21.8003 15.8711 21.9644 15.8717 22.1039 15.941L41.8051 25.7316Z",
    fill: "none",
    stroke: "#414042",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8544 19.7323C42.2244 19.9164 42.2243 20.4445 41.854 20.628L22.2006 30.3669C22.0586 30.4373 21.8908 30.4359 21.7497 30.3636L2.27816 20.383C1.91216 20.1954 1.91639 19.6702 2.28547 19.4888L21.7098 9.94045C21.8496 9.87177 22.013 9.87176 22.1525 9.94097L41.8544 19.7323Z",
    fill: "none",
    stroke: "#414042",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay);
export default __webpack_public_path__ + "static/media/Overlay.d995cd7c32c3d151dcf825f506f8bb82.svg";
export { ForwardRef as ReactComponent };